export default __webpack_public_path__ + "static/media/sales.753791b6.svg";